import React, { useMemo } from 'react';

import { IconButton, ImportExportIcon } from '@gogame/components';

import {
  useFiltersStateManager,
  isEqualFilterValues,
} from './FiltersStateManager';

const EqualizeFilters = ({ disabled }) => {
  const { getFilterValues, setFilterValues } = useFiltersStateManager();

  const [baseCollection, collection] = getFilterValues();

  const handleEqualizeFilters = () => {
    setFilterValues([baseCollection, baseCollection]);
  };

  const equal = useMemo(() => {
    return isEqualFilterValues(baseCollection, collection);
  }, [baseCollection, collection]);

  return (
    <IconButton
      icon={<ImportExportIcon />}
      tooltip={'Equalize all filters'}
      onClick={handleEqualizeFilters}
      disabled={disabled || equal}
    />
  );
};

export default EqualizeFilters;
